module.exports = __webpack_public_path__ + "static/img/3.868a682.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/eng/3.png
// module id = ae5D
// module chunks = 0